import { 
  collection, 
  getDocs, 
  query, 
  orderBy, 
  where,
  QueryConstraint
} from "firebase/firestore";
import Failure from "../../../core/Failure";
import { firestore } from "../../../firebase.config";
import { EProductType } from "@leedpulse-monorepo/enums";
import { FIREBASE_COLLECTIONS } from "@leedpulse-monorepo/consts";
import { ICreditMap, IPlanPrice } from "@leedpulse-monorepo/interfaces";

interface PlanOptions {
  product?: EProductType;
}

export interface ISmallPlan {
  id: string;
  name: string;
  price: IPlanPrice;
  credits: ICreditMap;
}

async function getPlansRefs(
  options?: PlanOptions
): Promise<{
  plansRefs: ISmallPlan[];
}> {
  try {
    const db = firestore;
    const plansCollection = collection(db, FIREBASE_COLLECTIONS.PLANS);

    const plansConstraints = [];

    // Add product option
    if (options?.product) {
      plansConstraints.push(where('product', '==', options.product));
    }

    const queryConstraints: QueryConstraint[] = [
      ...plansConstraints,
      // select(['id']), // todo : impossible -> passer en fetch backend pour + opti (necessaire ?)
      orderBy("name", "asc"),
    ];

    const results = await getDocs(query(plansCollection, ...queryConstraints));

    const plansRefs: ISmallPlan[] = [];
    results.docs.forEach((doc) => {
      plansRefs.push({
        id: doc.id,
        name: doc.data().name,
        price: doc.data().price,
        credits: doc.data().credits,
      });
    });


    return {
      plansRefs,
    };
  } catch (e) {
    console.log("error: ", e);
    throw new GetPlansFailure();
  }
}

export class GetPlansFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getPlansRefs;
